import { Box, Typography } from "@mui/material";

const ReleaseNote2 = () => {
  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Release 2.0
      </Typography>

      <Typography variant="body2" sx={{ mb: 3 }}>
        Introducing new forms and workflow enhancements in JUNE’s Document Generation module to streamline filing preparation.
      </Typography>

      <Box>
        <Typography variant="h5" sx={{ mb: 2 }}>
          <strong>Key Updates and Enhancements</strong>
        </Typography>
        <Typography variant="body2">
          <strong>New Forms Added – Document Generation</strong> <br />
        </Typography>
        <ul style={{ margin: 0, paddingLeft: "5%" }}>
          <li style={{ marginBottom: "12px" }}>
            <Typography variant="body2">
                  Change of Correspondence Address
            </Typography>
                <Typography variant="body2">
                  – AIA-122 (for patented cases)
                </Typography>

                <Typography variant="body2">
                  – AIA-123 (for pending applications)
                </Typography>
          </li>
          <li style = {{marginBottom: '12px'}}>
            <Typography variant="body2">
                RCE Transmittal (SB-30)
            </Typography>
          </li>
          <li style = {{marginBottom: '12px'}}>
            <Typography variant="body2">
                POA + 37 CFR – Workflow Enhancement
            </Typography>
            <span>You can now generate a merged copy of POA and 37 CFR in a single PDF for faster preparation and submission.</span>
            <br></br>
            <br></br>
            <span>Refer to the FAQ and Tutorial sections for more details on this feature.</span>
          </li>
        </ul>
      </Box>
    </Box>
  );
};

export default ReleaseNote2;